import { render, staticRenderFns } from "./ResidentEnter.vue?vue&type=template&id=a9f8a3f6&scoped=true&"
import script from "./ResidentEnter.vue?vue&type=script&lang=ts&"
export * from "./ResidentEnter.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentEnter.vue?vue&type=style&index=0&id=a9f8a3f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f8a3f6",
  null
  
)

export default component.exports